// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2GGcc","question":"Question_question__1mTCh","description":"Question_description__22VGY"};